import { APICallV3Post, APICallV4Post } from 'reactApp/api/APICall';

export class R7EditApiAPICallV3 extends APICallV3Post {
    _method = 'r7/edit';
}

export class R7EditApiAPICallV4 extends APICallV4Post {
    _method = 'r7/edit';
}
